<template>
  <header id="header" :class="navbarColor">
    <!--logo start-->
    <div :class="`brand ${navbarColor} hidden-sm-and-down`">
      <router-link
        :to="{ name: user ? 'home' : 'login' }"
        class="logo"
      >
        {{ appName }}
      </router-link>
    </div>
    <!--logo end-->
    <ul
      v-if="user"
      class="nav navbar-nav navbar-left"
    >
      <li class="toggle-navigation toggle-left">
        <button
          id="toggle-left"
          :class="`sidebar-toggle ${navbartoggleColor}`"
          @click="toggleSidebar"
        >
        <i class="fa fa-bars" />
          <!-- <svg id="hamButton" class="ham hamRotate ham7" viewBox="10 10 80 80" width="40">
            <path
                class="line top"
                d="m 70,33 h -40 c 0,0 -6,1.368796 -6,8.5 0,7.131204 6,8.5013 6,8.5013 l 20,-0.0013" />
            <path
                class="line middle"
                d="m 70,50 h -40" />
            <path
                class="line bottom"
                d="m 69.575405,67.073826 h -40 c -5.592752,0 -6.873604,-9.348582 1.371031,-9.348582 8.244634,0 19.053564,21.797129
                  19.053564,12.274756 l 0,-40" />
          </svg> -->
        </button>
      </li>
    </ul>
    <!-- <ul class="nav navbar-nav navbar-left">
          <li class="toggle-navigation toggle-left">
              <locale-dropdown />
          </li>
      </ul> -->
    <ul class="nav navbar-right">
      <!-- Authenticated -->
      <li
        v-if="user"
        class="dropdown profile hidden-xs"
      >
        <a
          :class="`nav-link dropdown-toggle sidebar-toggle ${navbartoggleColor}`"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ user.name }}
        </a>
        <div class="dropdown-menu">
          <router-link
            :to="{ name: 'settings.profile' }"
            class="dropdown-item pl-3"
          >
          <v-chip
            color="success darken-1"
            dark
          >
          <fa
              icon="user"
              fixed-width
            />
            {{ $t('profile') }}
          </v-chip>
          </router-link>

          <div class="dropdown-divider" />
          <a
            href="#"
            class="dropdown-item pl-3"
            @click.stop="dialog = true"
          >
            <v-chip
            color="red darken-1"
            dark
          >
            <fa
              icon="sign-out-alt"
              fixed-width
            />
            {{ $t('logout') }}
          </v-chip>
          </a>
        </div>
      </li>
    </ul>
    <ul
      v-if="user"
      class="nav navbar-nav navbar-left hidden-sm-and-down"
    >
      <li class="toggle-navigation toggle-left">
        <button
          id="toggle-left"
          :class="`sidebar-toggle ${navbartoggleColor}`"
          @click.prevent="openModalInfo()"
        >
          <i class="fa fa-phone" />
        </button>
      </li>
    </ul>
    <ul class="nav navbar-left">
      <li
        v-if="user"
        class="dropdown profile hidden-xs hidden-sm-and-down"
      >
        <a
          :class="`nav-link dropdown-toggle sidebar-toggle ${navbartoggleColor}`"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
        <i class="fa fa-bell" />
        <span v-if="count_notify > 0" class="notification-badge">{{ count_notify }}</span>
        </a>
        <div class="dropdown-menu">
          <a
            class="dropdown-item pl-3"
          >
          <v-chip
            color="green"
            dark
          >
          Tienes {{ count_notify }} {{ $t('notification') }}
          </v-chip>
          </a>

          <div class="dropdown-divider" />
          <router-link
            :to="{ name: 'notification' }"
            class="dropdown-item pl-3"
          >
          <v-chip
            color="red"
            dark
          >
            Ver más {{ $t('notification') }}
          </v-chip>
          </router-link>
        </div>
      </li>
    </ul>
    <v-dialog
      v-model="dialog"
      max-width="480"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Está seguro que desea cerrar sesión?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click.prevent="logout"
          >
            Cerrar Sesión
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogInfo"
      max-width="800"
    >
      <v-card>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-tabs
                        v-model="currentTab"
                        bg-color="primary"
                        show-arrows
                        :color="themeColor"
                    >
                        <v-tab value="currentTab">
                              <h1>Contactanos</h1>
                        </v-tab>
                        <!-- <v-tab value="support">
                              <h1>Soporte</h1>
                        </v-tab>
                        <v-tab value="integration">
                              <h1>Integraciones</h1>
                        </v-tab>
                        <v-tab value="sales">
                              <h1>Ventas</h1>
                        </v-tab> -->
                        <v-tab value="more">
                              <h1>Más</h1>
                        </v-tab>
                    </v-tabs>
                </v-col>
            </v-row>
            <v-tabs-items v-model="currentTab">
                <v-tab-item
                    key="contact"
                >
                <h1>
                  Teléfonos:
                  <a :href="contactInfo.phoneHref" target="_blank">
                    {{ contactInfo.phone }}
                  </a>
                </h1>
                <h1>
                  Correo Información:
                  <a :href="contactInfo.emailHref" target="_blank">
                    {{ contactInfo.email }}
                  </a>
                </h1>
                </v-tab-item>
                <v-tab-item key="more">
                <h1>
                  Pagina Web:
                  <a :href="contactInfo.websiteHref" target="_blank">
                    {{ contactInfo.website }}
                  </a>
                </h1>
                <h1>
                  Wiki:
                  <a :href="contactInfo.wikiHref" target="_blank">
                    {{ contactInfo.wiki }}
                  </a>
                </h1>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialogInfo = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-menu
      :close-on-content-click="false"
      :nudge-width="150"
    >
      <template v-slot:activator="{ on, attrs }">
        <span :class="`fixed-button ${navbarColor}`" v-bind="attrs" v-on="on">
          <v-tooltip bottom>
            <template
              v-slot:activator="{ on }"
            >
              <v-icon v-on="on" class="theme-icon" color="white">mdi-palette-advanced</v-icon>
            </template>
            <span>Temas</span>
          </v-tooltip>
        </span>
      </template>
      <v-card>
        <div style="min-height: 110px">
          <v-row>
            <v-col cols="12" style="text-align: center;">Temas</v-col>
          </v-row>
          <v-row style="margin-left:20px !important">
            <v-btn
              class="theme-btn"
              x-small
              :color="themeColor"
              @click="setTheme('blue')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="red darken-1"
              @click="setTheme('red')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="purple darken-1"
              @click="setTheme('purple')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="green darken-1"
              @click="setTheme('green')"
            ></v-btn>
          </v-row>
          <v-row style="margin-left:20px !important">
            <v-btn
              class="theme-btn"
              x-small
              color="orange darken-1"
              @click="setTheme('orange')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="pink lighten-1"
              @click="setTheme('fucsia')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="teal lighten-1"
              @click="setTheme('teal')"
            ></v-btn>
            <v-btn
              class="theme-btn"
              x-small
              color="light-blue lighten-1"
              @click="setTheme('lightblue')"
            ></v-btn>
          </v-row>
        </div>
      </v-card>
    </v-menu>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from 'vform';

export default {
  data: () => ({
    currentTab: 'contact',
    appName: window.config.appName,
    dialog: false,
    dialogInfo: false,
    check: '',
    apiURL: 'api/notification/getNotificationCount?type_portal=DISTRIBUIDOR',
    apiURLCheck: 'api/notification/checkNotification?type_portal=DISTRIBUIDOR',
    form2: new Form({
      type_change: 0,
      busy: false,
    }),
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
    },
  }),
  async mounted() {
    if (this.user) {
      this.loadCount();
    }
    if (this.navbarColor === undefined) {
      this.setTheme('blue');
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      token: 'auth/token',
      navbarColor: 'theme/navbarColor',
      navbartoggleColor: 'theme/navbartoggleColor',
      themeColor: 'theme/themeColor',
    }),
    visible: {
      get() {
        return this.$store.state.sidebar.visible;
      },
      set(value) {
        this.$store.dispatch('sidebar/setSidebarVisible', { value });
      },
    },
    mini: {
      get() {
        return this.$store.state.sidebar.mini;
      },
      set(value) {
        this.$store.dispatch('sidebar/setSidebarMini', { value });
      },
    },
    count_notify() {
      return this.$store.state.sidebar.count_notify;
    },
    isEbipac() {
      const env = String(process.env.VUE_APP_ENV || '').toLowerCase();
      return env === 'ebipac' || env === 'ebi' || env.startsWith('ebi');
    },
    contactInfo() {
      if (this.isEbipac) {
        return {
          phone: '383-0760',
          phoneHref: 'tel:+5073830760',
          email: 'info@ebi-pac.com',
          emailHref: 'https://mail.google.com/mail/?view=cm&to=info@ebi-pac.com',
          website: 'www.ebi-pac.com',
          websiteHref: 'https://www.ebi-pac.com',
          wiki: 'https://wiki.ebi-pac.com/',
          wikiHref: 'https://wiki.ebi-pac.com/',
        };
      }

      return {
        phone: '+507 6862. 55.43',
        phoneHref: 'https://wa.me/51986000880',
        email: 'contacto_pa@fhefactoryhka.com',
        emailHref: 'https://mail.google.com/mail/?view=cm&to=contacto_pa@fhefactoryhka.com',
        website: 'https://thefactoryhka.com.pa/',
        websiteHref: 'https://thefactoryhka.com.pa/',
        wiki: 'https://felwiki.thefactoryhka.com.pa',
        wikiHref: 'https://felwiki.thefactoryhka.com.pa',
      };
    },
  },
  watch: {
    $route() {
      if (this.user) {
        this.loadCount();
      }
    },
  },
  methods: {
    loadCount() {
      window.axios.get(`${this.apiURL}`)
      .then((response) => {
        const count = Number(response.data) || 0;
        this.$store.dispatch('sidebar/setSidebarCountNotify', { value: count });
      });

      window.axios.get(`${this.apiURLCheck}`)
      .then((response) => {
        this.check = response.data;
      });
    },
    openModalInfo() {
        this.dialogInfo = true;
    },
    async logout() {
      this.dialog = false;
      await this.$store.dispatch('auth/logout');

      // Redirect to login.
      this.$router.push({ name: 'login' });
    },

    toggleSidebar() {
      this.visible = !this.visible;
      this.mini = !this.mini;
    },
    resetForm() {
      this.$refs.form.reset();
    },
    setTheme(color) {
      this.$store.dispatch('theme/setThemeColor', { value: color });
    },
  },
};
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}

.navbar-right{
  margin-right: 60px;
  min-width: 130px;
}
.max-height {
  height: 60px !important;
}

.notification-dot {
  height: 9px;
  width: 9px;
  background-color: #c90b0b;
  border-radius: 50%;
  border: 1px solid white;
  display: inline-block;
  position: relative;
  top: -10px;
  left: -3px;
}

.notification-badge {
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  background-color: #c90b0b;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 17px;
  text-align: center;
  border-radius: 9px;
  border: 1px solid white;
  display: inline-block;
  position: relative;
  top: -10px;
  left: -6px;
}
</style>
